import React, { useState } from 'react';
import { FaCrown } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import ThanksPage from './thanks_page';

const RegistrationForm = () => {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        name: '',
        number: '',
        countryCode: '+966', // Add default country code (Saudi Arabia)
        nationality: '',
        dob: '',
        branch: '', // Add branch field
        instagramId: '', // New field for Instagram ID
    });
    const [customNationality, setCustomNationality] = useState(false);
    const [showThanks, setShowThanks] = useState(false);

    const countryCodes = [
        { code: '+971' }, // United Arab Emirates
        { code: '+91' },  // India
        { code: '+92' },  // Pakistan
        { code: '+880' }, // Bangladesh
        { code: '+20' },  // Egypt
        { code: '+63' },  // Philippines
        { code: '+1' },   // United States
        { code: '+44' },  // United Kingdom
        { code: '+49' },  // Germany
        { code: 'Varies' } // Other Nationalities (Generalized)
    ];

    const nationalities = [
        { code: "🇦🇪", name: "United Arab Emirates" },
        { code: "🇮🇳", name: "India" },
        { code: "🇵🇰", name: "Pakistan" },
        { code: "🇧🇩", name: "Bangladesh" },
        { code: "🇪🇬", name: "Egypt" },
        { code: "🇵🇭", name: "Philippines" },
        { code: "🇺🇸", name: "United States" },
        { code: "🇬🇧", name: "United Kingdom" },
        { code: "🇩🇪", name: "Germany" },
        { code: "🌍", name: "Other" }
    ];

    const branches = [
        { name: "Town" },
        { name: "Sanaiya" }
    ];

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Send data to Google Sheets
        try {
            const response = await fetch('https://script.google.com/macros/s/AKfycby5Z_d9E2cLTqkHHh3D8KXlzOaW3X1GnMLe9d-dCc96FfgdddFv_kRxVP_LZFd_Tw1JgA/exec', {
                method: 'POST',
                mode: 'no-cors',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
            });

            if (!response) {
                throw new Error('Network response was not ok');
            }

            setShowThanks(true);
        } catch (error) {
            console.error('Error storing data:', error);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === 'nationality' && value === 'Other') {
            setCustomNationality(true);
            setFormData({
                ...formData,
                nationality: ''
            });
        } else {
            setFormData({
                ...formData,
                [name]: value
            });
        }
    };

    const handleCloseModal = () => {
        setShowThanks(false);
        navigate('/'); // Navigate to main page
    };

    return (
        <div className="bg-black p-4 sm:p-8 relative min-h-screen">
            <div className="max-w-2xl mx-auto">
                {/* Header Section */}
                <div className="text-center mb-8">
                    <h1 className="text-3xl sm:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-yellow-300 to-yellow-500 mb-4">
                        Join Our Royalty Club
                    </h1>
                    <p className="text-xl text-blue-100 font-medium italic">
                        "Where Every Foodie is Treated Like Royalty"
                    </p>
                </div>

                {/* Form Section */}
                <div className="bg-white/10 backdrop-blur-lg rounded-2xl p-6 sm:p-8 shadow-xl border-2 border-blue-300">
                    <form onSubmit={handleSubmit} className="space-y-6">
                        <div className="space-y-2">
                            <label className="block text-yellow-300 font-semibold">
                                👑 Your Royal Name
                            </label>
                            <input
                                type="text"
                                name="name"
                                value={formData.name}
                                onChange={handleChange}
                                required
                                className="w-full px-4 py-3 rounded-lg bg-blue-900/50 text-white placeholder-blue-200 border-2 border-blue-400 focus:border-yellow-400 focus:outline-none transition-colors"
                                placeholder="Enter your full name"
                            />
                        </div>

                        <div className="space-y-2">
                            <label className="block text-yellow-300 font-semibold">
                                📱 Contact
                            </label>
                            <div className="flex gap-1 sm:gap-2">
                                <select
                                    name="countryCode"
                                    value={formData.countryCode}
                                    onChange={handleChange}
                                    className="w-16 sm:w-20 px-1 sm:px-2 py-3 rounded-lg bg-blue-900/50 text-white placeholder-blue-200 border-2 border-blue-400 focus:border-yellow-400 focus:outline-none transition-colors text-sm sm:text-base"
                                >
                                    {countryCodes.map((country) => (
                                        <option key={country.code} value={country.code}>
                                            {country.code}
                                        </option>
                                    ))}
                                </select>
                                <input
                                    type="tel"
                                    name="number"
                                    value={formData.number}
                                    onChange={handleChange}
                                    required
                                    className="flex-1 px-2 sm:px-4 py-3 rounded-lg bg-blue-900/50 text-white placeholder-blue-200 border-2 border-blue-400 focus:border-yellow-400 focus:outline-none transition-colors text-sm sm:text-base"
                                    placeholder="Enter phone number"
                                />
                            </div>
                        </div>

                        <div className="space-y-2">
                            <label className="block text-yellow-300 font-semibold">
                                🌍 Nationality
                            </label>
                            {!customNationality ? (
                                <select
                                    name="nationality"
                                    value={formData.nationality}
                                    onChange={handleChange}
                                    required
                                    className="w-full px-4 py-3 rounded-lg bg-blue-900/50 text-white placeholder-blue-200 border-2 border-blue-400 focus:border-yellow-400 focus:outline-none transition-colors"
                                >
                                    <option value="">Select your nationality</option>
                                    {nationalities.map((nation) => (
                                        <option key={nation.name} value={nation.name}>
                                            {nation.code} {nation.name}
                                        </option>
                                    ))}
                                </select>
                            ) : (
                                <input
                                    type="text"
                                    name="nationality"
                                    value={formData.nationality}
                                    onChange={handleChange}
                                    required
                                    className="w-full px-4 py-3 rounded-lg bg-blue-900/50 text-white placeholder-blue-200 border-2 border-blue-400 focus:border-yellow-400 focus:outline-none transition-colors"
                                    placeholder="Enter your nationality"
                                />
                            )}
                            {customNationality && (
                                <button
                                    type="button"
                                    onClick={() => setCustomNationality(false)}
                                    className="mt-2 text-yellow-300 text-sm hover:text-yellow-400"
                                >
                                    ← Back to list
                                </button>
                            )}
                        </div>

                        <div className="space-y-2">
                            <label className="block text-yellow-300 font-semibold">
                                🎂 Birthday
                            </label>
                            <input
                                type="date"
                                name="dob"
                                value={formData.dob}
                                onChange={handleChange}
                                required
                                className="w-full px-4 py-3 rounded-lg bg-blue-900/50 text-white placeholder-blue-200 border-2 border-blue-400 focus:border-yellow-400 focus:outline-none transition-colors"
                            />
                        </div>

                        <div className="space-y-2">
                            <label className="block text-yellow-300 font-semibold">
                                🏢 Branch
                            </label>
                            <select
                                name="branch"
                                value={formData.branch}
                                onChange={handleChange}
                                required
                                className="w-full px-4 py-3 rounded-lg bg-blue-900/50 text-white placeholder-blue-200 border-2 border-blue-400 focus:border-yellow-400 focus:outline-none transition-colors"
                            >
                                <option value="">Select your branch</option>
                                {branches.map((branch) => (
                                    <option key={branch.name} value={branch.name}>
                                        {branch.name}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div className="space-y-2">
                            <label className="block text-yellow-300 font-semibold">
                                📸 Instagram ID
                            </label>
                            <input
                                type="text"
                                name="instagramId"
                                value={formData.instagramId}
                                onChange={handleChange}
                                className="w-full px-4 py-3 rounded-lg bg-blue-900/50 text-white placeholder-blue-200 border-2 border-blue-400 focus:border-yellow-400 focus:outline-none transition-colors"
                                placeholder="Enter your Instagram ID"
                            />
                        </div>

                        <button
                            type="submit"
                            className="w-full bg-gradient-to-r from-yellow-400 to-yellow-500 hover:from-yellow-500 hover:to-yellow-600 text-blue-900 font-bold py-4 px-8 rounded-xl transform hover:scale-105 transition-all duration-300 shadow-lg flex items-center justify-center gap-2"
                        >
                            <FaCrown className="text-xl" />
                            Submit
                        </button>
                    </form>

                    <div className="mt-6 text-center text-blue-100 text-sm">
                        <p className="animate-pulse">
                            👑 Limited Royal Seats Available! 👑
                        </p>
                        <p className="mt-2">
                            Join us for an extraordinary culinary experience at the Royal Championship 2024
                        </p>
                    </div>
                </div>
            </div>

            {/* Thanks Modal */}
            {showThanks && (
                <div className="fixed inset-0 flex items-center justify-center z-50">
                    <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" 
                         onClick={handleCloseModal}>
                    </div>
                    <div className="relative w-full max-w-4xl mx-4">
                        <ThanksPage isModal={true} onClose={handleCloseModal} />
                    </div>
                </div>
            )}
        </div>
    );
};

export default RegistrationForm;
